
  import React from 'react';
  import './Other.css';


  const Publications = function(props){

    var data_pubs = [
      {
        img: "img/pubs/minnesota.png",
        title: "Wavelet-Based visual analysis for data exploration",
        authors: "Dal Col, A., Valdivia, P., Petronetto, F., Dias, F., Silva, C. T., & Nonato, L. G",
        booktitle: "Computing in Science & Engineering",
        year: "2017",
        volume: "19",
        number: "5",
        pages: "pp. 85-91",
        pdf: "files/wavex_cise2017.pdf",
        link: "https://doi.org/10.1109/MCSE.2017.3421553"
      },{
        img: "img/pubs/signal_coefs.png",
        title: "Wavelet-based visual analysis of dynamic networks",
        authors: "Dal Col, A., Valdivia, P., Petronetto, F., Dias, F., Silva, C. T., & Nonato, L. G",
        booktitle: "IEEE transactions on visualization and computer graphics",
        year: "2017",
        pdf: "files/dynwav_tvcg2017.pdf",
        link: "https://doi.org/10.1109/TVCG.2017.2746080"
      },
      {
        img: "img/pubs/pipeline_wav.png",
        title: "Wavelet-based visualization of time-varying data on graphs",
        authors: "P. Valdivia, F. Dias, F. Petronetto, C. T. Silva and L. G. Nonato",
        booktitle: "Visual Analytics Science and Technology (VAST), 2015 IEEE Conference on, Chicago, IL",
        year: "2015",
        pdf: "files/waviz_vast2015.pdf",
        link: "http://dx.doi.org/10.1109/VAST.2015.7347624"
      },{
        img: "img/pubs/hyper.png",
        title: "Watersheds on hypergraphs for data clustering",
        authors: "Dias, F., Mansour, M. R., Valdivia, P., Cousty, J., & Najman, L.",
        booktitle: "International Symposium on Mathematical Morphology and Its Applications to Signal and Image Processing",
        pages: "pp. 211-221",
        year: "2017",
        pdf: "files/hyper_morphology2017.pdf",
        link: "https://doi.org/10.1007/978-3-319-57240-6_17"
      },
      {
        img: "img/pubs/pipe_bil.png",
        title: "Normal correction towards smoothing point-based surfaces ",
        authors: "P. Valdivia, D. Cedrim, F. Petronetto, A. Paiva and L.G. Nonato",
        booktitle: "Proceedings of the 2013 XXVI Conference on Graphics, Patterns and Images",
        pages: "pp. 187-194",
        year: "2013",
        pdf: "files/normal_sib13.pdf",
        link: "http://dx.doi.org/10.1109/SIBGRAPI.2013.34"
      }
    ];

    var publications = data_pubs.map((pub, i) => {
      return(
        <span key={i}>
          <dl className="publication">
            <dt className="figure">
              {pub.img && <img alt={pub.title} src={pub.img} /> }
            </dt>
            <dd className="ref">
              <span className="ptitle"> {pub.title} </span>
              <span className="authors"> {pub.authors} </span>
              <span className="booktitle"> {pub.booktitle}, </span>
              {pub.pages && <span className="pages"> {pub.pages}, </span>}
              <span className="year"> {pub.year}.</span>
              {pub.pdf && <span className="document"> <a href={pub.pdf}> <img alt="pdf" src="img/pdf.png" className="icon" /> </a> </span>}
              {pub.link && <span className="document"> <a href={pub.link}> <img alt="doi" src="img/doi.png" className="icon" /> </a></span>}
              {pub.demo && <span className="document"> <a href={pub.demo}> live demo </a> </span>}
              {pub.git && <span className="document"> <a href={pub.git}> <img alt="pdf" src="img/github.png" className="icon" /> </a> </span>}
            </dd>
          </dl>
          <div className="space"></div>
        </span>
      );
    });

    return (
    <div id="pubs" className="publications">

      <div className="space"></div>
      <h2>
        PUBLICATIONS
      </h2>
      <div className="space"></div>


      {publications}

      <div className="space-lg"></div>

    </div>
  );
}

export default Publications;



// WEBPACK FOOTER //
// ./src/Publications.js